import './App.css';
import ICAL from 'ical.js';
import calData from './de-id-cal-data.ics'
import React, { Component } from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";

class App extends Component {
  constructor() {
    super();
    this.state = {
      events: [],
      structuredEvents: null
    }
  }

  componentDidMount() {
    fetch(calData)
    .then(r => r.text())
    .then(text => {
      const decodedText = text;
      const calDataRead = ICAL.parse(decodedText);
      const componentData = new ICAL.Component(calDataRead)
      const vevents = componentData.getAllSubcomponents('vevent');
      vevents.forEach((vevent, index) => {
        var event = new ICAL.Event(vevent)
        if (this.state.events.filter(e => e.summary === this.getSummary(event)).length < 1) {
          this.state.events.push(this.createEvent(event));
        }
      });
      const sampleoverlap = this.eventAttendeeOverlap(this.state.events[3], this.state.events, "jane.goodall@work.biz");
      console.log("sampleOverlap", sampleoverlap);

      const displayData = this.createEventDataStructure(this.state.events);
      console.log("display data", displayData);
      this.setState({
        structuredEvents: displayData
      });
      console.log("state", this.state);
      this.createChartAndSeries();
    });
  }

  createChartAndSeries() {
    // Create chart
    var chart = am4core.create("chartdiv", am4plugins_forceDirected.ForceDirectedTree);

    // Create series
    var networkSeries = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())
    networkSeries.dataFields.linkWith = "linkWith";
    networkSeries.dataFields.name = "name";
    networkSeries.dataFields.id = "name";
    networkSeries.dataFields.value = "value";
    networkSeries.dataFields.children = "children";

    networkSeries.nodes.template.label.text = "{name}"
    networkSeries.fontSize = 8;
    networkSeries.linkWithStrength = 0;

    var nodeTemplate = networkSeries.nodes.template;
    nodeTemplate.tooltipText = "{name}";
    nodeTemplate.fillOpacity = 1;
    nodeTemplate.label.hideOversized = true;
    nodeTemplate.label.truncate = true;

    var linkTemplate = networkSeries.links.template;
    linkTemplate.strokeWidth = 1;
    var linkHoverState = linkTemplate.states.create("hover");
    linkHoverState.properties.strokeOpacity = 1;
    linkHoverState.properties.strokeWidth = 2;

    nodeTemplate.events.on("over", function (event) {
      var dataItem = event.target.dataItem;
      dataItem.childLinks.each(function (link) {
        link.isHover = true;
      })
    })

    nodeTemplate.events.on("out", function (event) {
      var dataItem = event.target.dataItem;
      dataItem.childLinks.each(function (link) {
        link.isHover = false;
      })
    })

    networkSeries.data = this.state.structuredEvents;
    console.log("NETWORL", networkSeries)
  }

  componentWillMount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  createEventDataStructure(events) {
    var finalStructure = [];
    events.forEach(event => {
      var eventStructure = {
        name: event.summary,
        value: event.durationInSeconds / 60,
        linkWith: this.eventAttendeeOverlap(event, events),
        children: this.attendeesToChildren(event) //TODO HERE make this method
      };
      console.log("EVENTstruct", eventStructure)
      finalStructure.push(eventStructure);

    });
    console.log("FIJNA:Lstruct", finalStructure)
    return finalStructure;
  }

  attendeesToChildren(event) {
    var children = [];
    if (event.attendees.length) {
      event.attendees.forEach(child => {
        const childObject = {
          name: child.email
        }
        children.push(childObject)
      });
    }
    return children;
  }

  createEvent(icalEvent) {
    var event = {};
    event.summary = this.getSummary(icalEvent);
    event.attendees = this.getAttendees(icalEvent);
    event.durationInSeconds = this.getDuration(icalEvent);
    event.start = this.getStart(icalEvent);
    event.end = this.getEnd(icalEvent);
    event.id = this.getId(icalEvent);
    return event;
  }

  getSummary(icalEvent) {
    return icalEvent.summary;
  }

  getAttendees(icalEvent) {
    var attendees = [];
    if(!icalEvent.attendees.length > 0) {
      return attendees;
    }
    icalEvent.attendees.forEach(attendee => {
      var property = attendee.jCal[1];
      var email = property['cn'];
      var acceptanceStatus = property['partstat'];
      var attendeeCreated = {};
      attendeeCreated.email = email;
      attendeeCreated.status = acceptanceStatus;
      attendees.push(attendeeCreated);
    });
    return attendees;
  }

  getDuration(icalEvent) {
    var icalDuration = icalEvent.duration;
    return icalDuration.toSeconds();
  }

  getStart(icalEvent) {
    var icalStartDate = icalEvent.startDate;
    return icalStartDate.toUnixTime();
  }

  getEnd(icalEvent) {
    var icalStartDate = icalEvent.endDate;
    return icalStartDate.toUnixTime();
  }

  getId(icalEvent) {
    var icalId = icalEvent.uid;
    return icalId;
  }

  /*
  Call this on each event to be displayed (event)
  give it the array of events (events)

  default for overlap threshold is provided, 
  but can be overwritten on calling by just providing a parameter in position 3
  I wanted to make it easily mutable so the user can specify that preference
  To qualify, an event has to have mutual overlap significance (otherwise a meeting of two people would ping all the time)
  50% is probably not high enough, but that's easily tweaked.

  I provided an upper limit too. 
  I figure these meetings are too big to be of much use
  again the user can set a preferrence. 
  */
  eventAttendeeOverlap(event, events, userEmail, overlapThreshold = 0.5, upperLimit = 20){
    // to be populated with the IDs of overlapping events
    var foundConnections = [];
    const numberOfAttendees = event.attendees.length;

    // if there are no attendees, don't evaluate
    if(numberOfAttendees) {
      
      // populate emails to an array for comparison
      // don't add the user's email so it never is factored as a point of comparison
      const eventAttendees = [];
      event.attendees.forEach(attendee => {
        if ( attendee.email !== userEmail ) eventAttendees.push(attendee.email)
      });

      const eventId = event.id;

      // loop over all other events
      events.forEach(otherEvent => {
        const numberOfAttendeesInOther = otherEvent.attendees.length;

        // check that the other event has attendees, not too many, and isn't the event of comparison
        if (numberOfAttendeesInOther && numberOfAttendeesInOther < upperLimit && otherEvent.id !== eventId){
          var matches = 0;
          const otherEventAttendees = otherEvent.attendees;

          // loop over the emails of the other event and see if any match our event of comparison
          otherEventAttendees.forEach(attendee => {
            if(eventAttendees.includes(attendee.email)) matches++;
          });

          // find ratio of matching emails to total emails
          const eventPercent = matches / numberOfAttendees;
          const otherEventPercent = matches / numberOfAttendeesInOther;

          // only add to the array if both meet the threshold
          if( eventPercent >= overlapThreshold && otherEventPercent >= overlapThreshold ) {
            foundConnections.push(otherEvent.summary)
          }
        }
      });
    }

    return foundConnections;
  }


  // James' notes:
  // ICAL is some good npm.
  // This documentation is useful: https://mozilla-comm.github.io/ical.js/api/ICAL.Component.html

  // I put the test calendar in the same folder because that's the only way I could get it to work. 
  // S  t  r  e  t  c  h    G  o a l : put it in a folder.

  // Asynchronicity is an issue. 
  // react's "{}" within the rendered dom is a bit funny. 
  // like, you can have it referring to a string in the state
  // but if you try to drill within the dom you are out of luck. 
  // i.e., this DOESN'T WORK:
  // { this.state.calData[2][2][1][11][3] }
  // IDK why. Something to investigate

  // the parsing work within componentDidMount() is helping, but we can't just work with arrays... or can we? 
  // (I mean, that's miserable, but if we just want to cheat with these static data...)

  // 2021-03-25 KKO: Weaving in some amchart code per their React tutorial (https://www.amcharts.com/docs/v4/getting-started/integrations/using-react/)

  render(){
    if(this.state.structuredEvents){
      console.log(" DATA", this.state.structuredEvents)
    return (
    <div className="App">
      <header className="App-header">
        <p>CALeidoscope. . . visualize your schedule differently</p>
      </header>
      <div>
        <p>
          Currently experiencing <strong>Bubble Feels</strong>
        </p>
      </div>
      <div id="chartdiv" style={{ width: "100%", height: "500px" }}></div>
      <footer>
        <div class="selection-buttons-div">
        <p>
          <span class="selection-buttons"><a href="/">Explore</a></span>
          <span class="selection-buttons selection-buttons-border"><a href="/">Calibrate</a></span>
        </p>  
        </div>
        <div>
          <p>&#169; <a href="team.html">Team Mayo</a> Hack the Gap 2021</p>
        </div>
      </footer>
    </div>
  );
    }
    else
    {

      console.log("NO DATA")
  return (
  <div className="App">
    <header className="App-header">
      <p>CALeidoscope. . . visualize your schedule differently</p>
    </header>
    <div>
      <p>
        Currently experiencing <strong>Bubble Feels</strong>
      </p>
    </div>
    <div  id="chartdiv" > loading . . . </div>
    <footer>
        <div class="selection-buttons-div">
        <p>
          <span class="selection-buttons"><a href="/">Explore</a></span>
          <span class="selection-buttons selection-buttons-border"><a href="/">Calibrate</a></span>
        </p>  
        </div>
        <div>
          <p>&#169; <a href="team.html">Team Mayo</a> Hack the Gap 2021</p>
        </div>
      </footer>
  </div>
);
  
      
}
  }   
}

export default App;